<template>
  <section class="form-list">
    <el-form
      ref="form"
      :model="details"
      label-position="right"
      label-width="150px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="申请时间">{{ details.add_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="申请者">
        <v-avatar-nickname
          :value="details.admin_avatar"
          :nickname="details.admin_nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="申请门店">{{ details.store_name }}</el-form-item>

      <el-form-item label="老师昵称">{{ details.nickname }}</el-form-item>

      <el-form-item label="老师头像">
        <v-avatar :value="details.avatar" :size="50"></v-avatar>
      </el-form-item>

      <el-form-item label="手机号">{{ details.phone }}</el-form-item>

      <el-form-item label="企业微信号">{{ details.we_chat || '-' }}</el-form-item>

      <el-form-item label="微博号">{{ details.micro_blog || '-' }}</el-form-item>

      <el-form-item label="美拍号">{{ details.mei_pai || '-' }}</el-form-item>

      <el-form-item label="个人简介">{{ details.brief || '-' }}</el-form-item>

      <el-form-item label="不在小程序列表展示">
        <el-switch :disabled="true" v-model="details.is_hide_in_list" :active-value="1" :inactive-value="0"/>
      </el-form-item>

      <el-form-item label="审核状态">
        <span v-if="!isLoading && !isLoadingError" :class="`${applyState.tagType}-color`">{{ applyState.name }}</span>
      </el-form-item>

      <template v-if="!isLoading && !isLoadingError && applyState.timeLabel && (canViewReviewInfo)">
        <el-form-item :label="applyState.timeLabel">{{ details.update_time | timeToYmdHi }}</el-form-item>
        <el-form-item :label="applyState.personLabel">
          <v-avatar-nickname
            :value="details.admin_avatar_update"
            :nickname="details.admin_nickname_update"
            :is-center="false"
          />
        </el-form-item>
      </template>

      <el-form-item v-if="applyState.value === applyStates.rejected.value && (canViewReviewInfo)" label="驳回原因">
        <span class="danger-color">{{ details.remark || '' }}</span>
      </el-form-item>

      <el-form-item v-if="applyState.value === applyStates.passed.value && isAdministrator" label="审核备注">
        <span v-if="details.remark" class="danger-color">{{ details.remark }}</span>
        <span v-else class="info-color">未填写</span>
      </el-form-item>

      <template
        v-if="!isLoading && !isLoadingError && details.state === applyStates.review.value"
      >
        <template v-if="isAdministrator">
          <el-form-item label="审核结果">
            <el-radio v-model="isReject" :label="0" :disabled="isExamining">通过</el-radio>
            <el-radio v-model="isReject" :label="1" :disabled="isExamining">驳回</el-radio>
          </el-form-item>

          <el-form-item :label="isReject ? '驳回原因' : '审核备注'" :prop="isReject ? 'remark' : ''">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4 }"
              :placeholder="`请输入 2 ~ 200 字的${isReject ? '驳回原因' : '审核备注'}`"
              v-model="details.remark"
              :maxlength="200"
              show-word-limit
              clearable
              :disabled="isExamining"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleExamine" :loading="isExamining">完成审核</el-button>
            <el-button @click="RouteConfig.teacherAddApplyList.back">返回</el-button>
          </el-form-item>
        </template>

        <el-form-item v-else>
          <el-button type="primary" @click="handleRevoke" :loading="isRevoking">撤销</el-button>
          <el-button @click="RouteConfig.teacherAddApplyList.back">返回</el-button>
        </el-form-item>
      </template>
      <el-form-item v-else>
        <el-button @click="RouteConfig.teacherAddApplyList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update, destroy } from '@/api/teacher-add-apply';
import { applyStates, findApplyState } from "@/enums/applyStates";
import { mapGetters } from 'vuex';

export default {
  name: RouteConfig.teacherAddApplyDetail.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isLoadingError: false,
    isExamining: false,
    isRevoking: false,
    isReject: 0,

    applyStates,
    details: {
      add_time: 0,
      update_time: 0,
      add_administrator_id: 0,
      update_administrator_id: 0,
      state: applyStates.review.value,
      remark: '',
      store_id: 0,
    },
    rules: {
      remark: [{ required: true, message: '请输入驳回原因', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.details.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
    applyState() {
      return findApplyState(this.details.state)[0] || {};
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoadFailed = false;
      const { isError, data } = await show(this.id);
      if (isError || !data) return this.isLoadFailed = true;

      this.details = data;
    },
    handleExamine() {
      if (this.isExamining) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isExamining = true;
        this.isReject ? this.handleReject() : this.handlePass();
      });
    },
    async handleRevoke() {
      if (this.isExamining) return;

      this.isExamining = true;
      const { isError } = await destroy(this.id);
      this.isExamining = false;
      if (!isError) RouteConfig.teacherAddApplyList.push({ state: applyStates.revoked.value });
    },
    async handleReject() {
      const { isError } = await update(this.id, { remark: this.details.remark });
      this.isExamining = false;
      if (!isError) RouteConfig.teacherAddApplyList.push({ state: applyStates.review.value });
    },
    async handlePass() {
      const { isError } = await update(this.id, { is_passed: 1, remark: this.details.remark });
      this.isExamining = false;
      if (!isError) RouteConfig.teacherAddApplyList.push({ state: applyStates.review.value });
    },
  },
};
</script>
